const appHost = import.meta.env.VITE_API_HOST || 'http://localhost:3000';
const oauthAppPath = `${appHost}/auth`;
const sentryDsn =
  process.env.NODE_ENV === 'production'
    ? import.meta.env.VITE_SENTRY_DSN || ''
    : '';

export { appHost, oauthAppPath, sentryDsn };
